<div class="modal-header"></div>
<div class="modal-body">
  <p>{{ mensaje }}</p>
  <label>Comuníquese con el supervisor de su aeroplanta</label>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="onCerrarSesionClick()">Cerrar sesión</button>
</div>